import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Login from './Login';
import StartReset from './StartReset';
import RequireAuth from './RequireAuth';
import PasswordPage from './PasswordPage';
import PasswordStart from './PasswordStart';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pw-start" element={<PasswordStart />} />
      <Route path="/reset-password" element={<PasswordPage />} />
      <Route path="/accept-invite" element={<PasswordPage />} />
      <Route path="/set-password" element={<PasswordPage />} />
      <Route path="/start-reset" element={<StartReset />} />
      <Route path="/*" element={<RequireAuth><App /></RequireAuth>} />
    </Routes>
  </BrowserRouter>
);
